import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import EditLawyer from './pages/ViewLawyers/ViewLawyers';
// import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
    en: {
        translation: {
            // English translations
            welcome: 'Welcome',
            addRow: 'Add Row',
            removeRow: 'Remove Row',
            createNew: 'Create New',
            edit: 'Edit',
            delete: 'Delete',
            logIn: 'Log In',
            logOut: 'Log Out',
            fileUpload: 'File Upload',
            proposals: 'Proposals',
            switchLanguage: 'Switch Language',
            language: 'Proposal Language',
            changeAccount: 'Change Account',
            proposal: 'Proposal',
            dateEdited: 'Last Edited',
            editProposal: 'Edit Proposal',
            title: 'Title',
            description: 'Description',
            caseInfo: 'Case Information',
            lawyerInput: 'User Input',
            generateProposal: 'Generate Proposal',
            scopeOfWork: 'Scope of Work',
            introduction: 'Introduction',
            assumptions: 'Why WKB',
            assumptionsTooltip:
                'Assumptions generation is enhanced by using the already generated scope section. This allows for better alignment of assumptions with the specific scope of work and ensures consistency between these sections.',
            fees: 'Fees',
            positionEn: 'Position (English)',
            positionPl: 'Position (Polish)',
            fallbackTitle: 'no position found in database, using professional title',
            rate: 'Rate',
            generatedByAI: 'Generated by AI',
            lawyers: 'Lawyers',
            experience: 'Experiences',
            projectTitle: 'Project Title',
            client: 'Client',
            addExperience: 'Add Experience',
            addLawyer: 'Add Lawyer',
            save: 'Save',
            cancelChanges: 'Cancel Changes',
            generateWordDoc: 'Generate Word Document',
            deleteProposal: 'Delete Proposal',
            addTitleHere: 'Add your title here',
            provideCaseInfo:
                'Provide information pertaining to the case e.g. an email from a potential client or simply a description of it. This will be used by an LLM to assign lawyers automatically.',
            addYourInputTextHere: 'Add your input text here.',
            clientRepresentative: 'Client Representative',
            clientCompany: 'Client Company',
            addYourIntroHere: 'Add your introduction here',
            addScopeOfWorkHere: 'Add scope of work here',
            addAssumptionsHere: 'Add assumptions here',
            llmAssignedLawyers:
                'An LLM has automatically assigned lawyers and explained their suitability for the task given their experience.',
            loading: 'Loading...',
            loadingBio: 'Loading Bio...',
            confirmDeletion: 'Confirm Deletion',
            confirmDeleteProposal: 'Are you sure you want to delete this proposal?',
            confirm: 'Confirm',
            humanInput: 'The fields below should be filled in by a human',
            reset: 'Reset',
            resetIntroduction: 'Reset Introduction',
            resetIntroductionConfirmation:
                'Are you sure you want to reset the introduction? It will reset the introduction to the default setting of the currently selected document language and will remove all changes.',
            introLetter: `
Dear _____

thank you for inviting the law firm WKB Wierciński, Kwieciński, Baehr ("WKB") to present an offer of legal assistance for _____.

In response to your request, below we provide information about the firm, details related to the scope of our advice in this proposal and present our previous experience and the team of lawyers dedicated to the assignment.

In our opinion, the knowledge and experience of our team members ensure that WKB can offer you comprehensive legal services at the highest level. We hope that our offer will meet your expectations. 

If you have any question, do not hesitate to contact us. We will be very happy to answer any of them you may have.

Kind regards,
`,
            introLine1:
                'thank you for inviting the law firm WKB Wierciński, Kwieciński, Baehr ("WKB") to present an offer of legal assistance for',
            introRest: `In response to your request, below we provide information about the firm, details related to the scope of our advice in this proposal and present our previous experience and the team of lawyers dedicated to the assignment.

In our opinion, the knowledge and experience of our team members ensure that WKB can offer you comprehensive legal services at the highest level. We hope that our offer will meet your expectations. 

If you have any question, do not hesitate to contact us. We will be very happy to answer any of them you may have.

Kind regards,`,
            uploadedFiles: 'Uploaded Files',
            searchFiles: 'Search files...',
            dragDrop: "Drag 'n' drop some files here, or click to select files",
            errorFetchingAlert: 'Failed to fetch file list.',
            successfulFileUpload: 'Files uploaded successfully:',
            unsuccessfulFileUpload: 'Files not uploaded successfully:',
            noFilesUploaded: 'None',
            noMatchFiles: 'No files match the search criteria.',
            cancel: 'Cancel',
            deleteFileConfirmation: 'Are you sure you want to delete',
            name: 'Full Name',
            surname: 'Surname',
            email: 'Email',
            phoneNumber: 'Phone Number',
            positionAccountPage: 'Position',
            location: 'Location',
            userDetails: 'User Details',
            addDescription: 'Add description',
            addBio: 'Add biography',
            experienceIntro: 'Experiences Introduction',
            addExperienceIntroHere: 'Add experiences introduction here',

            // Add other translations here
            account: 'Account',
            lawyerInfo: 'Lawyer Information',
            lawyerName: "Lawyer's Full Name",
            editLawyer: 'Edit Lawyer',
            expertise: 'Expertise',
            seniority: 'Seniority',
            selectExpertise: 'Select expertise',
            searchLawyer: 'Search by lawyer name',
            lawyerDetails: 'Lawyer Details',
            bio: 'Bio',
            requiredLawyers: 'Required Lawyers',
            selectRequiredLawyers: 'Select required lawyers',
            numberOfLawyers: 'Number of Lawyers',
            constraints: 'Requirements',
            provideConstraints: 'Provide requirements for the proposal',
            teamComposition: 'Team Composition',
            provideTeamComposition:
                'Define team members and what relevant expertise they require (if any).',
            representatives: 'Representatives',
            selectRepresentatives: 'Select representatives',
            warsaw: 'Warsaw',
            poznan: 'Poznań',
            relevantDocuments: 'Documents',
            describeLawyerDocuments:
                'Documents the LLM has decided have experiences relevant to this lawyer.',
            doc: 'Document',
            date: 'Date',
            quantity: 'Quantity',
            provideSeniority:
                'List what minimum requirements of seniority levels are needed on the team.',
            feeType: 'Fee Type',
            currency: 'Currency',
            retainer: 'Retainer',
            hourly: 'Hourly Rate',
            blendedRate: 'Blended Rate',
            addBlendedRate: 'Add Blended Rate',
            lumpSum: 'Lump Sum',
            retainerAmount: 'Retainer Amount',
            billingFrequency: 'Billing Frequency',
            weekly: 'Weekly',
            monthly: 'Monthly',
            quarterly: 'Quarterly',
            yearly: 'Yearly',
            pickALawyer: 'Pick a lawyer',
            english: 'English',
            polish: 'Polish',
            lawyerBiography:
                "Additional biographical information about the lawyer to be fed into the LLM for proposal generation - i.e. information that is unlikely to appear in the documents already uploaded or hasn't been put anywhere all in one place.",
            deleteImage: 'Delete Image',
            UploadProfileImage: 'Upload Image',
            wkbRep: 'WKB Representatives',
            proposalLanguageTooltip: 'The language the proposal will be generated in.',
            numberOfExperiences: 'Number of Experiences',
            teamCompositionComplaint:
                'Generation constraints must be defined. Please add at least one team, or at least one required lawyer, or at least one experience.',
            provideContextFile: 'Upload file pertaining to case',
            representativesTooltip:
                'The WKB representatives writing the letter to the client. Note - the first person in this list will have their contact details automatically entered at the bottom of the word template.',
            clientSectorPlaceholder: 'Input client sector here',
            clientSector: 'Client Sector',
            proposalDate: 'Proposal Date',
            cancelGeneration: 'Cancel Generating',
            requiredLawyersDescription:
                "Specify any lawyers you would like to include in the proposal independent of the LLM's suggestions. These lawyers will be added to the lawyer counts specified above.",
            experienceNumbersDescription:
                'Specify the number of experiences you would like to include in the proposal.',
            specialRoles: 'Special Roles',
            partnerResponsible: 'Partner responsible for the contact with the client',
            lawyerResponsible: 'The lawyer directly responsible for the commission',
            selectLawyer: 'Select lawyer',
            specialRolesInfo:
                'Lawyers with special roles must be selected from the lawyers with bios generated in the section above',
            caseOverview: 'Case Overview',
            generate: 'Generate',
            regenerate: 'Regenerate',
            saveSuccess: 'Success!',
            proposalSaved: 'Your proposal has been saved',
            saveError: 'Error!',
            failedToSaveProposal: 'Failed to save proposal',
            proposalNotFoundTitle: 'Proposal not found',
            proposalNotFoundMsg: 'The proposal you tried to open no longer exists.',
            generateLawyers: 'Generate Lawyers',
            generateFurtherLawyers: 'Generate Further Lawyers',
            generateExperiences: 'Generate Experiences',
            generateFurtherExperiences: 'Generate Further Experiences',
            professionalTitleEn: 'Professional Title (English)',
            professionalTitlePl: 'Professional Title (Polish)',
            confirmDeleteImage: 'Are you sure you would like to delete this image?',
            confirmRegeneration: 'Confirm Regeneration',
            confirmRegenerateScope:
                'Are you sure you would like to regenerate the scope of work? It will overwrite all previous work on the scope of work section.',
            confirmRegenerateAssumptions:
                'Are you sure you would like to regenerate the assumptions? It will overwrite all previous work on the assumptions section.',
            regenerateWarning:
                'This will regenerate the document from scratch based on your original prompt, do you wish to continue?',
            addFee: 'Add Fee',
            hourlyRate: 'Hourly Rate',
            firstSection: 'Case Overview',
            secondSection: 'Scope and Fees',
            thirdSection: 'Lawyers and Experiences',
            type: 'Type',
            lumpSumAmount: 'Fixed',
            lumpSumRange: 'Range',
            lumpSumMax: 'Max',
            lumpSumType: 'Fee Type',
            directCharge: 'Direct Charge',
            feeEstimate: 'Fee Estimate',
            cappedFee: 'Capped Fee',
            top: 'Upper Limit',
            bottom: 'Lower Limit',
            fee: 'Fee',
            text: 'Text',
            feeTextDescription: 'Enter supplementary text description here',
            addIntroduction: 'Add Introduction',
            addConclusion: 'Add Conclusion',
            hourlyRateIntro: 'WKB lawyers provide legal services at the following hourly rates:',
            hourlyRateClosing: '',
            lumpSumIntro:
                'We estimate (based on our experience with similar assignments and the assumptions listed above) that our fee for the services listed above should be:',
            lumpSumClosing: '',
            retainerIntro: '',
            retainerClosing: '',
            accessManagement: 'Access Management',
            userManagement: 'User Management',
            role: 'Role',
            searchUsers: 'Search users...',
            filterByRole: 'Filter by role',
            allRoles: 'All roles',
            editUserRole: 'Edit user role',
            selectRole: 'Select Role',
            sendEmailNotification: 'Send email notification',
            assign: 'Assign',
            confirmUserDeletion: 'Confirm User Deletion',
            confirmDeleteMessage:
                'Are you sure you want to delete {name}? This action cannot be reversed and the user will have to sign up again.',
            noUsersFound: 'No users found',
            createdAt: 'Date Created',
            updatedAt: 'Last Updated',
            error: 'Error',
            warning: 'Warning',
            info: 'Information',
            success: 'Success',
            noNewFilesToUpload: 'No new files to upload.',
            filename: 'Filename',
            status: 'Status',
            processed: 'Processed',
            pending: 'Pending',
            lawyerInformationUpdated: 'Lawyer information updated successfully.',
            failedToUpdateLawyer: 'Failed to update lawyer information.',
            failedToFetchLawyer: 'Failed to fetch lawyer information.',
            imageDeletedSuccessfully: 'Image deleted successfully.',
            failedToDeleteImage: 'Failed to delete image.',
            resummariseRequirements:
                'Please fill Bio and select at least one Expertise before saving. These are required to summarise the profile.',
            noChangesToSave: 'No changes detected. Nothing to save.',
            unsavedChanges: 'Unsaved changes',
            letterSenders: 'Letter Senders',
            letterSendersTooltip:
                'The WKB representatives writing the letter to the client. These can only be selected from the list of lawyers in the third tab. Note - the first person in this list will have their contact details automatically entered at the bottom of the word template.',
            filterType: 'Filter Type',
            lawyerUpdated: 'Lawyer updated successfully.',
            lawyerExpertiseTable: 'Lawyer Expertise Table',
            viewLawyerExpertiseTable: 'View Lawyer Expertise Table',
            invalidDate: 'Invalid date',
            amount: 'Amount',
            period: 'Period',
            search: 'Search',
            errorLoadingFile: 'Error loading file',
            officeFileViewing:
                'This file type ({{filename}}) cannot be displayed directly in the browser.',
            downloadAndView: 'Download and View',
            downloadFile: 'Download File',
            unsupportedFileType: 'Unsupported file type: {{extension}}',
            close: 'Close',
            openInNewTab: 'Open in New Tab',
            uploadedBy: 'Uploaded By',
            uploadedAt: 'Upload Date',
            lawyerNameUpdated: 'Lawyer name updated successfully',
            lawyerNameExists: 'A lawyer with this name already exists',
            bioRequired: 'Bio is required.',
            expertiseRequired: 'Select at least one expertise.',
            deleteLawyer: 'Delete Lawyer',
            confirmDeleteLawyer: 'Are you sure you want to delete "{{name}}"?',
            deleteLawyerWarning:
                'This action cannot be undone. All associated data will be permanently removed.',
            lawyerDeletedSuccessfully: 'Lawyer deleted successfully',
            failedToDeleteLawyer: 'Failed to delete lawyer',
            noLawyersFound: 'No lawyers found',
            noProposalsFound: 'No proposals found',
            noFilesFound: 'No files uploaded yet',
            searchProposals: 'Search proposals...',
            filterBy: 'Filter by',
            allFields: 'All fields',
            noSearchResults: 'No proposals match your search',
            actions: 'Actions',
            displayId: 'Display ID',
            idUnavailable: 'ID Unavailable',
            searchIn: 'Search in',
            advancedFilters: 'Advanced Filters',
            filterByExpertise: 'Filter by Expertise',
            searchByName: 'Search by lawyer name',
            searchByPosition: 'Search by position',
            searchByTitle: 'Search by title',
            searchByExpertise: 'Search by expertise',
            nameShort: 'Name',
            positionShort: 'Position',
            titleShort: 'Title',
            expertiseShort: 'Expertise',
            fileMetadata: 'File Metadata',
            wentThrough: 'Went Through',
            failureReason: 'Failure Reason',
            extractedDate: 'Extracted Date',
            selectLawyers: 'Select Lawyers',
            enterClientName: 'Enter client name',
            enterDate: 'Select date',
            explainWhyDidntGoThrough: "Explain why this offer didn't go through",
            metadataUpdatedSuccessfully: 'File metadata updated successfully',
            failedToUpdateMetadata: 'Failed to update file metadata',
            yes: 'Yes',
            no: 'No',
            unknown: 'Unknown',
            searchByClient: 'Search by client',
            searchByLawyers: 'Search by lawyers',
            searchByStatus: 'Search by status',
            filterByStatus: 'Filter by Status',
            selectStatus: 'Select status',
            filterByLawyers: 'Filter by Lawyers',
            failed: 'Failed',
            won: 'Won',
            lost: 'Lost',
            pendingApproval: {
                title: 'Account Pending Approval',
                message:
                    'Your account has been created successfully, but access to the platform requires administrator approval due to the sensitive nature of the information contained within.',
                nextSteps: 'Next Steps:',
                step1: '1. An administrator has been notified of your registration',
                step2: '2. You will receive an email confirmation once access is granted',
                step3: '3. If urgent, please contact your system administrator directly',
                contactAdmin: 'Contact Admin',
                signOut: 'Sign Out',
                userInfo: 'Logged in as:',
            },
            downloadAllFiles: 'Download All Files',
            downloadAllProposals: 'Download All Proposals',
            batchDownloadStarted: 'Download started successfully.',
            zipNotReady: 'ZIP archive is not built yet. It will be generated automatically after the next file upload or deletion.',
            batchDownloadFailed: 'Failed to download files. Please try again.',
        },
    },
    pl: {
        translation: {
            // Polish translations
            welcome: 'Witamy',
            addRow: 'Dodaj wiersz',
            removeRow: 'Usuń wiersz',
            createNew: 'Utwórz nowy',
            edit: 'Edytuj',
            delete: 'Usuń',
            logIn: 'Zaloguj',
            logOut: 'Wyloguj',
            fileUpload: 'Przesyłanie plików',
            proposals: 'Oferty',
            switchLanguage: 'Zmień język',
            language: 'Język oferty',
            changeAccount: 'Zmień konto',
            proposal: 'Oferta',
            dateEdited: 'Ostatnio Edytowane',
            editProposal: 'Edytuj ofertę',
            title: 'Tytuł',
            description: 'Opis',
            caseInfo: 'Informacje dotyczące sprawy',
            lawyerInput: 'Sekcja do wypełnienia przez użytkownika',
            generateProposal: 'Wygeneruj ofertę',
            scopeOfWork: 'Zakres Doradztwa',
            introduction: 'Wstęp',
            assumptions: 'Dlaczego WKB',
            assumptionsTooltip:
                'Generowanie założeń jest ulepszone poprzez wykorzystanie już wygenerowanej sekcji zakresu. Pozwala to na lepsze dopasowanie założeń do konkretnego zakresu prac i zapewnia spójność między tymi sekcjami.',
            fees: 'Wynagrodzenie',
            position: 'Stanowisko',
            positionEn: 'Stanowisko (angielski)',
            positionPl: 'Stanowisko (polski)',
            fallbackTitle: 'brak stanowiska w bazie danych, użyto tytułu zawodowego',
            rate: 'Stawka',
            generatedByAI: 'Wygenerowane przez AI',
            lawyers: 'Prawnicy',
            experience: 'Przykładowe doświadczenia',
            projectTitle: 'Tytuł projektu',
            client: 'Klient',
            addExperience: 'Dodaj doświadczenie',
            addLawyer: 'Dodaj prawnika',
            save: 'Zapisz',
            cancelChanges: 'Anuluj zmiany',
            generateWordDoc: 'Generuj dokument Word',
            deleteProposal: 'Usuń ofertę',
            addTitleHere: 'Dodaj swój tytuł tutaj',
            provideCaseInfo:
                'Podaj szczegóły dotyczace sprawy, np. e-mail od potencjalnego klienta lub krótki jej opis. Informacje te zostana wykorzystane przez LLM do automatycznego przypisania odpowiednich prawników.',
            addYourInputTextHere: 'Wprowadź tekst tutaj',
            clientRepresentative: 'Przedstawiciel Klienta',
            clientCompany: 'Firma Klienta',
            addYourIntroHere: 'Wprowadź swój wstęp tutaj',
            addScopeOfWorkHere: 'Dodaj zakres pracy tutaj',
            addAssumptionsHere: 'Dodaj założenia tutaj',
            llmAssignedLawyers:
                'LLM automatycznie przypisał prawników i wyjaśnił ich dopasowanie do zadania w oparciu o ich doświadczenie.',
            loading: 'Ładowanie...',
            loadingBio: 'Ładowanie biografii...',
            confirmDeletion: 'Potwierdź usunięcie',
            confirmDeleteProposal: 'Czy na pewno chcesz usunąć tę ofertę?',
            confirm: 'Potwierdź',
            humanInput: 'Poniższe pola powinny zostać wypełnione przez użytkownika',
            reset: 'Resetuj',
            resetIntroduction: 'Resetuj Wstęp',
            resetIntroductionConfirmation:
                'Czy na pewno chcesz zresetować wstęp? Spowoduje to przywrócenie domyślnego wstępu dla aktualnie wybranego języka dokumentu i usunięcie wszystkich zmian.',
            introLetter: `
Szanowna Pani/Panie _____

dziękujemy za zaproszenie kancelarii WKB Wierciński, Kwieciński, Baehr sp. k. („WKB”) do przedstawienia oferty współpracy na świadczenie usług w zakresie […]

W odpowiedzi na Państwa zapytanie, poniżej przedstawiamy informacje o kancelarii, szczegóły związane z zakresem naszego doradztwa w ramach niniejszej oferty oraz prezentujemy nasze dotychczasowe doświadczenie i zespół prawników dedykowanych do realizacji zlecenia.

W naszej ocenie wiedza i doświadczenie członków naszego zespołu sprawia, że WKB może zaoferować Państwu kompleksową obsługę prawną na najwyższym poziomie. Mamy nadzieję, że nasza oferta spełni Państwa oczekiwania.

W przypadku jakichkolwiek pytań, uprzejmie prosimy o kontakt. Bardzo chętnie odpowiemy na wszelkie Państwa pytania.

Z poważaniem`,

            introLine1:
                'dziękujemy za zaproszenie kancelarii WKB Wierciński, Kwieciński, Baehr sp. k. („WKB”) do przedstawienia oferty współpracy na świadczenie usług w zakresie […]',
            introRest: `W odpowiedzi na Państwa zapytanie, poniżej przedstawiamy informacje o kancelarii, szczegóły związane z zakresem naszego doradztwa w ramach niniejszej oferty oraz prezentujemy nasze dotychczasowe doświadczenie i zespół prawników dedykowanych do realizacji zlecenia.

W naszej ocenie wiedza i doświadczenie członków naszego zespołu sprawia, że WKB może zaoferować Państwu kompleksową obsługę prawną na najwyższym poziomie. Mamy nadzieję, że nasza oferta spełni Państwa oczekiwania.

W przypadku jakichkolwiek pytań, uprzejmie prosimy o kontakt. Bardzo chętnie odpowiemy na wszelkie Państwa pytania.

Z poważaniem`,
            uploadedFiles: 'Przesłane pliki',
            searchFiles: 'Wyszukaj w plikach...',
            dragDrop: 'Przeciągnij i upuść pliki tutaj lub kliknij, aby wybrać pliki',
            errorFetchingAlert: 'Nie udało się pobrać listy plików.',
            successfulFileUpload: 'Pliki przesłane pomyślnie:',
            unsuccessfulFileUpload: 'Pliki nie zostały przesłane pomyślnie:',
            noFilesUploaded: 'Brak',
            noMatchFiles: 'Brak plików spełniających kryteria wyszukiwania.',
            cancel: 'Anuluj',
            deleteFileConfirmation: 'Czy na pewno chcesz usunąć',
            name: 'Imię i Nazwisko',
            surname: 'Nazwisko',
            email: 'Email',
            phoneNumber: 'Numer telefonu',
            positionAccountPage: 'Stanowisko',
            location: 'Lokalizacja',
            userDetails: 'Dane użytkownika',
            addDescription: 'Dodaj opis',
            addBio: 'Dodaj biografię',
            experienceIntro: 'Wstęp do doświadczeń',
            addExperienceIntroHere: 'Dodaj wstęp do doświadczeń',

            // Add other translations here
            account: 'Konto',
            lawyerInfo: 'Informacje o prawniku',
            lawyerName: 'Imię i nazwisko prawnika',
            editLawyer: 'Edytuj prawnika',
            expertise: 'Specjalizacja',
            seniority: 'Staż pracy',
            selectExpertise: 'Wybierz specjalizację',
            searchLawyer: 'Wyszukaj po imieniu i nazwisku',
            lawyerDetails: 'Szczegóły prawnika',
            bio: 'Biografia',
            requiredLawyers: 'Wymagani prawnicy',
            selectRequiredLawyers: 'Wybierz wymaganych prawników',
            numberOfLawyers: 'Liczba prawników',
            constraints: 'Wymagania',
            provideConstraints: 'Określ wymagania dotyczace oferty.',
            teamComposition: 'Skład zespołu',
            provideTeamComposition:
                'Zdefiniuj członków zespołu i jakie wymagane specjalizacje są potrzebne (jeśli jakieś).',
            representatives: 'Przedstawiciele',
            selectRepresentatives: 'Wybierz przedstawicieli',
            warsaw: 'Warszawa',
            poznan: 'Poznań',
            relevantDocuments: 'Dokumenty',
            describeLawyerDocuments:
                'Dokumenty, które LLM uznał za doświadczenia istotne dla tego prawnika.',
            doc: 'Dokument',
            date: 'Data',
            quantity: 'Ilość',
            provideSeniority: 'Podaj minimalne wymagania dotyczące poziomów stażu pracy w zespole.',
            feeType: 'Typ opłaty',
            currency: 'Waluta',
            retainer: 'Zaliczka',
            hourly: 'Stawka godzinowa',
            blendedRate: 'Stawka mieszana',
            addBlendedRate: 'Dodaj stawkę mieszaną',
            lumpSum: 'Stawka ryczałtowa',
            retainerAmount: 'Kwota zaliczki',
            billingFrequency: 'Częstotliwość rozliczeń',
            weekly: 'Tygodniowo',
            monthly: 'Miesięcznie',
            quarterly: 'Kwartalnie',
            yearly: 'Rocznie',
            pickALawyer: 'Wybierz prawnika',
            english: 'Angielski',
            polish: 'Polski',
            lawyerBiography:
                'Dodatkowe informacje biograficzne o prawniku do wprowadzenia do LLM w celu generowania oferty - tj. informacje, które są mało prawdopodobne, że pojawią się w już przesłanych dokumentach lub nie zostały umieszczone w jednym miejscu.',
            deleteImage: 'Usuń zdjęcie',
            UploadProfileImage: 'Prześlij zdjęcie',
            wkbRep: 'Przedstawiciele WKB',
            proposalLanguageTooltip: 'Język w którym wygenerowana zostanie oferta.',
            numberOfExperiences: 'Liczba doświadczeń',
            teamCompositionComplaint:
                'Musisz określić ograniczenia generacji. Dodaj przynajmniej jeden zespół, przynajmniej jednego wymaganego prawnika lub przynajmniej jedno doświadczenie.',
            provideContextFile: 'Prześlij plik dotyczący sprawy',
            representativesTooltip:
                'Przedstawiciele WKB odpowiedzialni za napisanie listu do klienta. Uwaga: dane kontaktowe pierwszej osoby z listy zostaną automatycznie dodane na końcu dokumentu Word.',
            clientSectorPlaceholder: 'Wprowadź sektor klienta',
            clientSector: 'Sektor Klienta',
            proposalDate: 'Data Oferty',
            cancelGeneration: 'Anuluj generowanie',
            requiredLawyersDescription:
                'Określ jakich prawników chciałbyś uwzględnić w ofercie niezależnie od sugestii LLM. Ci prawnicy zostaną dodani do liczby prawników określonej powyżej.',
            experienceNumbersDescription:
                'Określ liczbę doświadczeń, które chcesz uwzględnić w ofercie.',
            specialRoles: 'Role specjalne',
            partnerResponsible: 'Partner odpowiedzialny za kontakty z klientem',
            lawyerResponsible: 'Prawnik bezpośrednio odpowiedzialny za zlecenie',
            selectLawyer: 'Wybierz prawnika',
            specialRolesInfo:
                'Prawnicy ze specjalnymi rolami muszą być wybrani spośród prawników z wygenerowanymi biografiami w powyższej sekcji',
            caseOverview: 'Przegląd sprawy',
            generate: 'Generuj',
            regenerate: 'Regeneruj',
            saveSuccess: 'Sukces!',
            proposalSaved: 'Oferta zapisana',
            saveError: 'Błąd!',
            failedToSaveProposal: 'Nie udało się zapisać oferty',
            proposalNotFoundTitle: 'Nie znaleziono oferty',
            proposalNotFoundMsg: 'Oferta, którą próbujesz otworzyć, już nie istnieje.',
            generateLawyers: 'Generuj prawników',
            generateFurtherLawyers: 'Generuj dalszych prawników',
            generateExperiences: 'Generuj doświadczenia',
            generateFurtherExperiences: 'Generuj dalsze doświadczenia',
            professionalTitleEn: 'Profesjonalny tytuł (angielski)',
            professionalTitlePl: 'Profesjonalny tytuł (polski)',
            confirmDeleteImage: 'Czy na pewno chcesz usunąć to zdjęcie?',
            confirmRegeneration: 'Potwierdź Regenerację',
            confirmRegenerateScope:
                'Czy na pewno chcesz zregenerować zakres pracy? Ta operacja nadpisze wszystkie poprzednie zmiany w sekcji zakresu pracy.',
            confirmRegenerateAssumptions:
                'Czy na pewno chcesz zregenerować założenia? Ta operacja nadpisze wszystkie poprzednie zmiany w sekcji założeń.',
            regenerateWarning:
                'Ta operacja wygeneruje dokument od nowa na podstawie oryginalnego opisu. Czy chcesz kontynuować?',
            addFee: 'Dodaj opłatę',
            hourlyRate: 'Stawka godzinowa',
            firstSection: 'Przegląd sprawy',
            secondSection: 'Zakres i wynagrodzenie',
            thirdSection: 'Prawnicy i doświadczenia',
            type: 'Typ',
            lumpSumAmount: 'Stała',
            lumpSumRange: 'Zakres',
            lumpSumMax: 'Maksymalna',
            lumpSumType: 'Typ opłaty',
            top: 'Górna granica',
            bottom: 'Dolna granica',
            fee: 'Opłata',
            text: 'Tekst',
            feeTextDescription: 'Wprowadź dodatkowy opis tekstowy tutaj',
            addIntroduction: 'Dodaj wprowadzenie',
            addConclusion: 'Dodaj zakończenie',
            hourlyRateIntro:
                'Prawnicy WKB świadczą usługi prawne według następujących stawek godzinowych:',
            hourlyRateClosing: '',
            lumpSumIntro:
                'Oszacowaliśmy (na podstawie naszego doświadczenia z podobnych zleceń oraz założeń wymienionych powyżej), że nasze wynagrodzenie za usługi wymienione powyżej powinno wynieść:',
            lumpSumClosing: '',
            retainerIntro: '',
            retainerClosing: '',
            accessManagement: 'Zarządzanie dostępem',
            userManagement: 'Zarządzanie użytkownikami',
            role: 'Rola',
            searchUsers: 'Szukaj użytkowników...',
            filterByRole: 'Filtruj według roli',
            allRoles: 'Wszystkie role',
            editUserRole: 'Edytuj rolę użytkownika',
            selectRole: 'Wybierz rolę',
            sendEmailNotification: 'Wyślij powiadomienie email',
            assign: 'Przypisz',
            confirmUserDeletion: 'Potwierdź usunięcie użytkownika',
            confirmDeleteMessage:
                'Czy na pewno chcesz usunąć {name}? Ta akcja nie może być cofnięta i użytkownik będzie musiał zarejestrować się ponownie.',
            noUsersFound: 'Nie znaleziono użytkowników',
            createdAt: 'Utworzono',
            updatedAt: 'Ostatnia aktualizacja',
            error: 'Błąd',
            warning: 'Ostrzeżenie',
            info: 'Informacja',
            success: 'Sukces',
            noNewFilesToUpload: 'Brak nowych plików do przesłania.',
            filename: 'Nazwa pliku',
            status: 'Status',
            processed: 'Przetworzony',
            pending: 'Oczekujący',
            lawyerInformationUpdated: 'Informacje o prawniku zostały zaktualizowane.',
            failedToUpdateLawyer: 'Nie udało się zaktualizować informacji o prawniku.',
            imageDeletedSuccessfully: 'Zdjęcie zostało usunięte.',
            failedToDeleteImage: 'Nie udało się usunąć zdjęcia.',
            failedToFetchLawyer: 'Nie udało się pobrać informacji o prawniku.',
            letterSenders: 'Podpisujący ofertę',
            letterSendersTooltip:
                'Prawnicy WKB odpowiedzialni za napisanie listu do klienta. Uwaga: dane kontaktowe pierwszej osoby z listy zostaną automatycznie dodane na końcu dokumentu Word.',
            lawyerUpdated: 'Prawnik zaktualizowany pomyślnie.',
            resummariseRequirements:
                'Przed zapisem uzupełnij Biografię oraz wybierz co najmniej jedną Specjalizację. Są wymagane do podsumowania profilu.',
            noChangesToSave: 'Nie wykryto zmian. Nic do zapisania.',
            unsavedChanges: 'Niezapisane zmiany',
            lawyerExpertiseTable: 'Wykaz specjalizacji prawników',
            viewLawyerExpertiseTable: 'Zobacz tabelę specjalizacji prawników',
            filterType: 'Typ filtra',
            invalidDate: 'Nieprawidłowa data',
            cappedFee: 'Ograniczona opłata',
            directCharge: 'Opłata bezpośrednia',
            feeEstimate: 'Szacunkowa opłata',
            amount: 'Kwota',
            period: 'Okres',
            search: 'Szukaj',
            errorLoadingFile: 'Błąd podczas ładowania pliku',
            officeFileViewing:
                'Ten typ pliku ({{filename}}) nie może być wyświetlony bezpośrednio w przeglądarce.',
            downloadAndView: 'Pobierz i Zobacz',
            downloadFile: 'Pobierz Plik',
            unsupportedFileType: 'Nieobsługiwany typ pliku: {{extension}}',
            close: 'Zamknij',
            openInNewTab: 'Otwórz w nowej karcie',
            uploadedBy: 'Przesłane przez',
            uploadedAt: 'Data przesłania',
            lawyerNameUpdated: 'Nazwa prawnika została zaktualizowana',
            lawyerNameExists: 'Prawnik o tej nazwie już istnieje',
            bioRequired: 'Biografia jest wymagana.',
            bioPlaceholderPL: 'Dodaj biografię po polsku',
            expertiseRequired: 'Wybierz co najmniej jedną specjalizację.',
            deleteLawyer: 'Usuń prawnika',
            confirmDeleteLawyer: 'Czy na pewno chcesz usunąć "{{name}}"?',
            deleteLawyerWarning:
                'Ta operacja nie może być cofnięta. Wszystkie powiązane dane zostaną trwale usunięte.',
            lawyerDeletedSuccessfully: 'Prawnik został usunięty pomyślnie',
            failedToDeleteLawyer: 'Nie udało się usunąć prawnika',
            noLawyersFound: 'Nie znaleziono prawników',
            noProposalsFound: 'Nie znaleziono ofert',
            noFilesFound: 'Nie przesłano jeszcze żadnych plików',
            searchProposals: 'Szukaj ofert...',
            filterBy: 'Filtruj według',
            allFields: 'Wszystkie pola',
            noSearchResults: 'Żadne oferty nie pasują do wyszukiwania',
            actions: 'Akcje',
            displayId: 'ID Wyświetlania',
            idUnavailable: 'ID Niedostępne',
            searchIn: 'Szukaj w',
            advancedFilters: 'Filtry zaawansowane',
            filterByExpertise: 'Filtruj według specjalizacji',
            searchByName: 'Szukaj po imieniu i nazwisku',
            searchByPosition: 'Szukaj po stanowisku',
            searchByTitle: 'Szukaj po tytule',
            searchByExpertise: 'Szukaj po specjalizacji',
            nameShort: 'Nazwisko',
            positionShort: 'Stanowisko',
            titleShort: 'Tytuł',
            expertiseShort: 'Specjalizacja',
            fileMetadata: 'Metadane pliku',
            wentThrough: 'Zakończone sukcesem',
            failureReason: 'Powód niepowodzenia',
            extractedDate: 'Wyodrębniona data',
            selectLawyers: 'Wybierz prawników',
            enterClientName: 'Wprowadź nazwę klienta',
            enterDate: 'Wybierz datę',
            explainWhyDidntGoThrough: 'Wyjaśnij dlaczego ta oferta nie została zrealizowana',
            metadataUpdatedSuccessfully: 'Metadane pliku zostały zaktualizowane',
            failedToUpdateMetadata: 'Nie udało się zaktualizować metadanych pliku',
            yes: 'Tak',
            no: 'Nie',
            unknown: 'Nieznane',
            searchByClient: 'Szukaj po kliencie',
            searchByLawyers: 'Szukaj po prawnikach',
            searchByStatus: 'Szukaj po statusie',
            filterByStatus: 'Filtruj według statusu',
            selectStatus: 'Wybierz status',
            filterByLawyers: 'Filtruj według prawników',
            failed: 'Niepowodzenie',
            won: 'Wygrany',
            lost: 'Przegrany',
            pendingApproval: {
                title: 'Konto Oczekuje na Zatwierdzenie',
                message:
                    'Twoje konto zostało utworzone pomyślnie, ale dostęp do platformy wymaga zatwierdzenia przez administratora ze względu na poufny charakter zawartych w niej informacji.',
                nextSteps: 'Następne kroki:',
                step1: '1. Administrator został powiadomiony o Twojej rejestracji',
                step2: '2. Otrzymasz e-mail z potwierdzeniem po udzieleniu dostępu',
                step3: '3. W pilnych przypadkach skontaktuj się bezpośrednio z administratorem systemu',
                contactAdmin: 'Skontaktuj się z Administratorem',
                signOut: 'Wyloguj się',
                userInfo: 'Zalogowany jako:',
            },
            downloadAllFiles: 'Pobierz wszystkie pliki',
            downloadAllProposals: 'Pobierz wszystkie oferty',
            batchDownloadStarted: 'Pobieranie rozpoczęte pomyślnie.',
            zipNotReady: 'Archiwum ZIP nie zostało jeszcze utworzone. Zostanie wygenerowane automatycznie po następnym przesłaniu lub usunięciu pliku.',
            batchDownloadFailed: 'Nie udało się pobrać plików. Spróbuj ponownie.',
        },
    },
};

i18n
    //   .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        fallbackLng: 'pl', // Default language
        debug: true,
        interpolation: {
            escapeValue: false, // React already does escaping
        },
    });

export default i18n;
